import { call, put, takeEvery } from "redux-saga/effects";

import {
  ADD_LAB_PATHOLOGIST,
  GET_LAB_PATHOLOGISTS,
  DELETE_LAB_PATHOLOGIST,
} from "./actionTypes";

import {
  addLabPathologistSuccess,
  addLabPathologistFail,
  getLabPathologistsSuccess,
  getLabPathologistsFail,
  deleteLabPathologistsSuccess,
  deleteLabPathologistsFail,
} from "./actions";

import {
  addLabPathologist,
  getLabPathologists,
  deleteLabPathologist,
} from "../../helpers/django_api_helper";


function* onAddLabPathologist(object) {
  try {
    console.log("PAYLOAD:", object.payload);
    console.log("DATA:", object.payload.data);

    const response = yield call(
      addLabPathologist,
      object.payload.data
    );

    console.log("API SUCCESS:", response);

    yield put(addLabPathologistSuccess(response));
  } catch (error) {
    console.log("API ERROR:", error);
    yield put(addLabPathologistFail(error));
  }
}

function* onGetLabPathologists() {
  try {
    const response = yield call(getLabPathologists);
    yield put(getLabPathologistsSuccess(response));
  } catch (error) {
    yield put(getLabPathologistsFail(error));
  }
}

function* onDeleteLabPathologist({ payload }) {
  try {
    yield call(deleteLabPathologist, payload);

    yield put(deleteLabPathologistsSuccess(payload));

  } catch (error) {
    yield put(deleteLabPathologistsFail(error));
  }
}

function* LabPathologistSaga() {
  yield takeEvery(ADD_LAB_PATHOLOGIST, onAddLabPathologist);
  yield takeEvery(GET_LAB_PATHOLOGISTS, onGetLabPathologists);
  yield takeEvery(DELETE_LAB_PATHOLOGIST, onDeleteLabPathologist);
}

export default LabPathologistSaga;